/*eslint-disable*/

export const GROUP_INITIAL_STATE = {
    application: '',
    groupName:'',
    description: ''
};

export const CREATE_FORM_FIELDS_CONFIG = {
showApplication: true,
};